import { buildVenuePath } from '../utils/venueRouting';
import React, { useContext } from 'react';
import AppContext from '../contexts/AppContext';

const Error = () => {
    const { venueId } = useContext(AppContext);

    const handleReload = () => {
        window.location.assign(buildVenuePath('/', venueId));
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center p-6">
            <h1 className="text-4xl font-bold text-red-600 mb-4">Oops! Something went wrong</h1>
            <p className="text-lg text-gray-700 mb-6">
                We're sorry, but something went wrong. Please try again later or contact support if the issue persists.
            </p>
            <button
                onClick={handleReload}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
            >
                Refresh Page
            </button>
        </div>
    );
};

export default Error;